import { useEffect } from 'react';
import OInput from '../../../UI/FormControls/OInput';
import { useTranslation } from 'react-i18next';
import styles from './GeneralData.module.css';
import TextArea from '../../../UI/FormControls/TextArea';
import OAutocomplete from '../../../UI/MuiAutocomplete';
import useHttp from '../../../../hooks/use-http';
import { urls } from '../api/urls';
import AutocompleteMulti from '../../../UI/AutocompleteMulti';
import Field from './Field/Field';
import {
  currencyFormatDE,
  hiljadeFormat,
} from '../../../../../utils/currencyFormat';

const GeneralData = ({
  generalValue,
  setGeneralValue,
  tipId,
  machineData,
  machineValue,
}) => {
  const { t, i18n } = useTranslation();

  // #endregion
  console.log('GENERAL VALUE', generalValue);
  return (
    <div>
      <div
        style={{
          display: 'flex',
          width: '100%',
          borderBottom: '1px solid black',
        }}
      >
        <Field
          label={t('requestId')}
          value={generalValue.ceoBrDok}
          sValue={{ fontWeight: 'bold' }}
        />
        <Field
          label={t(machineValue.nazivTipaMasine)}
          value={machineValue.sifra}
        />
        <Field
          label={t('client')}
          value={generalValue.NazivFirmeKorisnikaPrograma}
        />
        <Field
          label={t('reportedBy')}
          value={generalValue.imeKorisnikaSlanjaZahteva}
        />
      </div>
      <Field label={t('title')} value={generalValue.naslov} />
      <div className={styles.radiosContainer}>
        <div className={styles.radioStatus}>
          <Field
            label={
              machineValue.nazivTipaMasine === 'Robot'
                ? t('robotStatus')
                : t('moldStatus')
            }
            value={generalValue.statusMasine}
            sValue={{
              color:
                generalValue.statusMasine === 'Van upotrebe' || 'Out of Use'
                  ? 'red'
                  : 'green',
              fontWeight: 'bold',
            }}
            style={{ width: '400px' }}
          />
        </div>
        <div className={styles.radioStatus}>
          <Field
            style={{ width: '400px' }}
            label={t('malfunctionType')}
            value={generalValue.listaVrstaKvarova.map((item) => {
              return `${item.vrednost}, `;
            })}
            // sValue={{ color: 'red', fontWeight: 'bold' }}
          />
        </div>
        <div className={styles.radioStatus}>
          <Field
            style={{ width: '200px' }}
            label={t('machine')}
            value={generalValue.nazivKlijentMasina}
            // sValue={{ color: 'red', fontWeight: 'bold' }}
          />
        </div>
        <div className={styles.radioStatus}>
          <Field
            style={{ width: '200px' }}
            label={t('Alat')}
            value={generalValue.nazivKlijentAlat}
            // sValue={{ color: 'red', fontWeight: 'bold' }}
          />
        </div>
      </div>
      <div style={{ display: 'flex' }}>
        <Field
          style={{ width: '400px' }}
          label={t('controlSystemErrorMessage')}
          value={generalValue.kodGreske}
          sValue={{ color: 'red' }}
        />
        <Field
          style={{ width: '400px' }}
          label={t('cycleCount')}
          value={hiljadeFormat(generalValue.brojSatiRada)}
          // sValue={{ color: 'red' }}
        />
        <div className={styles.radioStatus}>
          <Field
            style={{ width: '200px' }}
            label={t('product')}
            value={generalValue.nazivKlijentProizvod}
            // sValue={{ color: 'red', fontWeight: 'bold' }}
          />
        </div>
      </div>
      {/* <div className={styles.radiosContainer}>
        <div className={styles.radioStatus}>
          <Field
            label={`Status ${machineValue.nazivTipaMasine}`}
            value={generalValue.statusMasine}
            sValue={{
              color:
                generalValue.statusMasine === 'Van upotrebe' ? 'red' : 'green',
              fontWeight: 'bold',
            }}
            style={{ width: '400px' }}
          />
        </div>
        <div className={styles.radioStatus}>
          <Field
            style={{ width: '400px' }}
            label="Vrsta kvara"
            value={generalValue.listaVrstaKvarova.map((item) => {
              return `${item.vrednost}, `;
            })}
            // sValue={{ color: 'red', fontWeight: 'bold' }}
          />
        </div>
      </div> */}
      <Field
        style={{ width: '100%', marginTop: '20px' }}
        label={t('problemDescription')}
        value={generalValue.opisProblema}
      />
    </div>
  );
};

export default GeneralData;
